import debounce from 'lodash/debounce';

/**
 * AXIOS 的相应拦截器
 * 拦截接口返回的状态，和错误信息，如果没登陆调用重新登陆逻辑
 */
var interceptor = function interceptor() {
  var login = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var callback = debounce(login, 10);
  return {
    name: 'login',
    response: {
      fail: function fail(error) {
        var _error$response = error.response,
          response = _error$response === void 0 ? {} : _error$response;
        var status = response.status,
          _response$data = response.data,
          data = _response$data === void 0 ? {} : _response$data;
        if (status === 403 && data.result === 'userNotLogin') {
          try {
            callback(data);
          } catch (e) {}
        }
        return Promise.reject(error);
      }
    }
  };
};
function login (login) {
  this.$inject(interceptor(login));
}

export { login as default, interceptor };
